<template>
  <div v-html="html"></div>
</template>

<script setup lang="ts">
import axios, { AxiosError } from "axios";
import { ref, onMounted } from "vue";

const props = defineProps<{
  type: "stronger" | "weaker";
}>();

const html = ref<string>("");

async function fetchRazorPartial() {
  const API_URL = `/api/htmlpartial/viewpointscomparisons/${props.type}`;

  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (err) {
    const e = err as AxiosError;
    throw new Error(`Error fetching the report: ${e.response?.data}`);
  }
}

onMounted(async () => {
  html.value = await fetchRazorPartial();
});
</script>
